<mat-dialog-actions class="justify-content-between">

    <h4 class="f-s-16 f-w-600 m-b-16">
        <!-- @if(patientfill){ -->
        <!-- <h3>{{ 'LABEL.UPDATE_LABEL' | translate }} {{ 'ENTITY.HOSPITAL' | translate }}</h3> -->
        <!-- }@else{ -->
        <h3>{{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.HOSPITAL' | translate }}</h3>
        <!-- } -->
    </h4>
    <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="hospitalForm">
        <div class="row">
            <div class="col-lg-12">
                <div class="d-flex align-items-center m-b-16">
                    <div class="flex flex-col items-center relative" id="avatar-container"
                        (mouseenter)="showAddPhotoOverlay=true">
                        <!--  (mouseleave)="showAddPhotoOverlay=false" -->

                        <img class="avatar-photo" #avatarImg [src]="profileImagePathSrc" id="avatar-photo"
                            alt="User avatar" fallbackImage="assets/images/profile/user-1.jpg">


                        <div *ngIf="showAddPhotoOverlay" id="add-photo-overlay" class="avatar-photo"
                            style="text-align: center;">
                            <!-- Hover Button -->
                            <button id="add-avatar-photo-button" class="center-positon-absolute" mat-icon-button
                                (click)="fileInput.click();showAddPhotoOverlay=false">
                                <mat-icon>add_a_photo</mat-icon>
                            </button>

                        </div>

                    </div>
                    <input #fileInput type="file" (change)="onFileChanged($event)" name="avatar"
                        accept="image/png, image/jpeg" style="display:none;">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">

                <mat-form-field appearance="outline" class="w-100 m-b-15">
                    <mat-label>{{ 'LABEL.HOSPITAL_NAME' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'LABEL.HOSPITAL_NAME' | translate }}" formControlName="name"
                        maxlength="50">
                    <mat-error *ngIf="hospitalForm.get('name')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100 m-b-15">
                    <mat-label>{{ 'LABEL.PAN_LABEL' | translate }}</mat-label>
                    <input matInput appMaskInput maskType="pan" [masked]="hideData"
                        (maskedChange)="hideData = $event" #panMask="appMaskInput" style="text-transform: uppercase"
                        placeholder="{{ 'LABEL.PAN_LABEL' | translate }}" formControlName="panNumber" maxlength="10"
                        minlength="10">
                    <button mat-icon-button matSuffix type="button" (click)="panMask.toggleMask()">
                        <mat-icon class="icon-eye">{{ hideData ? 'visibility' : 'visibility_off' }}</mat-icon>
                    </button>
                    <mat-error *ngIf="hospitalForm.get('panNumber')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="hospitalForm.get('panNumber')?.hasError('invalidPan')">
                        {{ 'VALIDATION.PAN_NUMBER' | translate }}
                    </mat-error>
                    <mat-error *ngIf="hospitalForm.get('panNumber')?.hasError('maxLength')">
                        {{ 'REQUIRED.MAXIMUM10' | translate }}
                    </mat-error>
                    <mat-error *ngIf="hospitalForm.get('panNumber')?.hasError('minLength')">
                        {{ 'REQUIRED.MINIMUM10' | translate }}
                    </mat-error>

                </mat-form-field>
                <!-- input -->

                <mat-form-field appearance="outline" class="w-100 m-b-15">
                    <mat-label>{{ 'LABEL.REGISTRATION_NUMBER' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'LABEL.REGISTRATION_NUMBER' | translate }}"
                        formControlName="registrationNumber">
                    <mat-error *ngIf="hospitalForm.get('registrationNumber')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="hospitalForm.get('registrationNumber')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM20' | translate }}
                    </mat-error>
                    <mat-error *ngIf="hospitalForm.get('registrationNumber')?.hasError('pattern')">
                        {{ 'REQUIRED.REGISTRATION' | translate }}
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100 m-b-15">
                    <mat-label>{{ 'LABEL.PHONE_LABEL' | translate }}</mat-label>
                    <input matInput formControlName="phone" placeholder="Phone" maxlength="10" appAllowOnlyDigits>
                    <mat-error
                        *ngIf="hospitalForm.get('phone')?.hasError('minlength') || hospitalForm.get('phone')?.hasError('maxlength')">
                        {{ 'REQUIRED.MINIMUM10' | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100 m-b-15">
                    <mat-label>{{ 'LABEL.MOBILE_LABEL' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'LABEL.MOBILE_LABEL' | translate }}" formControlName="mobile"
                        maxlength="10" appAllowOnlyDigits />
                    <mat-error *ngIf="hospitalForm.get('mobile')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>

                    <mat-error *ngIf="hospitalForm.get('mobile')?.hasError('minlength') || 
                                                        hospitalForm.get('mobile')?.hasError('maxlength')">
                        {{ 'REQUIRED.MINIMUM10' | translate }}
                    </mat-error>
                </mat-form-field>
                <mat-slide-toggle formControlName="isIPD" color="primary">
                    {{ 'LABEL.IS_IPD' | translate }}
                </mat-slide-toggle>
            </div>
            <div class="col-sm-6">
                <!-- input -->
                <mat-form-field appearance="outline" class="w-100 m-b-15">
                    <mat-label>{{ 'LABEL.COUNTRY' | translate }}</mat-label>
                    <mat-select formControlName="country" (selectionChange)="onCountryChange($event.value)">
                        <mat-option *ngFor="let country of Countries" [value]="country.name">
                            {{country.name}}
                            <!-- ({{country.isoCode}}) -->
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100 m-b-15">
                    <mat-label>{{ 'LABEL.STATE' | translate }}</mat-label>
                    <mat-select formControlName="state" (selectionChange)="onStateChange($event.value)">
                        <mat-option *ngFor="let state of states" [value]="state.name">
                            {{state.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100 m-b-15">
                    <mat-label>{{ 'LABEL.CITY' | translate }} </mat-label>
                    <mat-select formControlName="city">
                        <mat-option *ngFor="let city of cities" [value]="city.name">
                            {{city.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100 m-b-15">
                    <mat-label>{{ 'LABEL.ADDRESS_LABEL' | translate }}</mat-label>
                    <textarea matInput placeholder="{{ 'LABEL.ADDRESS_LABEL' | translate }}" cols="5" rows="4"
                        formControlName="address"></textarea>
                    <mat-error *ngIf="hospitalForm.get('address')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.POSTALCODE_LABEL' | translate }} </mat-label>
                    <input type="text" matInput placeholder="{{ 'LABEL.POSTALCODE_LABEL' | translate }}"
                        formControlName="postalCode" maxlength="6" minlength="6">
                    <mat-error
                        *ngIf="hospitalForm.get('postalCode')?.hasError('pattern') && hospitalForm.get('postalCode')?.touched">
                        {{ 'REQUIRED.POSTALCODE' | translate }}
                    </mat-error>
                    <mat-error
                        *ngIf="hospitalForm.get('postalCode')?.hasError('maxLength') && hospitalForm.get('postalCode')?.touched">
                        {{ 'REQUIRED.MAXIMUM6' | translate }}
                    </mat-error>
                    <mat-error
                        *ngIf="hospitalForm.get('postalCode')?.hasError('minLength') && hospitalForm.get('postalCode')?.touched">
                        {{ 'REQUIRED.MINIMUM6' | translate }}
                    </mat-error>

                </mat-form-field>
            </div>
            <div class="col-6">

            </div>
        </div>

    </form>
    <div class="col-12 p-0">
        <form [formGroup]="UserForm">
            <div class="mat-body-1 rounded">
                <div class="b-1 p-10 rounded" style="border: 1px solid gray;">
                    <strong>
                        {{ 'USERDETAILS' | translate }}
                    </strong>

                    <div class="row m-t-10">
                        <div class="col-lg-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{ 'LABEL.FIRSTNAME_LABEL' | translate }}</mat-label>
                                <input matInput placeholder="{{ 'LABEL.FIRSTNAME_LABEL' | translate }}"
                                    formControlName="firstname">
                                <mat-error *ngIf="UserForm.get('firstname')?.hasError('required')">
                                    {{ 'REQUIRED.NAME' | translate }}
                                </mat-error>
                                <mat-error *ngIf="UserForm.get('firstname')?.hasError('maxlength')">
                                    {{ 'REQUIRED.MAXIMUM_20' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{ 'LABEL.LASTNAME_LABEL' | translate }}</mat-label>
                                <input matInput placeholder="{{ 'LABEL.LASTNAME_LABEL' | translate }}"
                                    formControlName="lastname">
                                <mat-error *ngIf="UserForm.get('lastname')?.hasError('required')">
                                    {{ 'REQUIRED.NAME' | translate }}
                                </mat-error>
                                <mat-error *ngIf="UserForm.get('lastname')?.hasError('maxlength')">
                                    {{ 'REQUIRED.MAXIMUM_20' | translate }}
                                </mat-error>
                            </mat-form-field>

                        </div>
                        <div class="col-lg-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{ 'LABEL.EMAIL_LABEL' | translate }}</mat-label>
                                <input type="email" matInput placeholder="{{ 'LABEL.EMAIL_LABEL' | translate }}"
                                    formControlName="email">
                                <mat-error *ngIf="UserForm.get('email')?.hasError('required')">
                                    {{ 'REQUIRED.EMAIL' | translate }}
                                </mat-error>
                                <mat-error *ngIf="UserForm.get('email')?.hasError('invalidEmail')">
                                    {{ 'VALIDATION.EMAIL' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{ 'LABEL.SELECT_ROLE' | translate }}</mat-label>

                                <mat-select formControlName="role" multiple>
                                    @for (user of userRole; track user) {
                                        <mat-option [value]="user">
                                        {{ user }}
                                        </mat-option>
                                    }
                                </mat-select>

                                <mat-error *ngIf="UserForm.get('role')?.hasError('required') &&
                                                (UserForm.get('role')?.dirty || UserForm.get('role')?.touched)">
                                {{ 'REQUIRED.SELECTED_VALUE' | translate }}
                                </mat-error>

                            </mat-form-field>
                        </div>
                        <div class="col-lg-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{ 'LABEL.USERNAME' | translate }}</mat-label>
                                <input matInput placeholder="{{ 'LABEL.USERNAME' | translate }}"
                                    formControlName="username" maxlength="50">
                                <mat-error *ngIf="UserForm.get('username')?.hasError('required')">
                                    {{ 'REQUIRED.USERNAME_REQUIRE' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{ 'LABEL.PASSWORD_LABEL' | translate }}</mat-label>
                                <input matInput [type]="hidePassword ? 'password' : 'text'" placeholder="Enter password"
                                    formControlName="password">

                                <button mat-icon-button matSuffix (click)="togglePasswordVisibility()" type="button">
                                    <mat-icon class="icon-eye">{{ hidePassword ? 'visibility' : 'visibility_off'
                                        }}</mat-icon>
                                </button>
                                <mat-error *ngIf="UserForm.get('password')?.hasError('required')">
                                    {{ 'REQUIRED.PASSWORD_REQUIRE' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>

            </div>
        </form>
    </div>

</mat-dialog-content>

<mat-divider></mat-divider>
<mat-dialog-actions>
    <div class="row m-t-4 p-r-16">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button (click)="onCloseDialog()" class="m-r-5">{{ 'BUTTON.BTN_CLOSE' |
                translate
                }}</button>
            <button mat-flat-button color="primary" class=" m-l-4" (click)="onSaveHospital()"
                [disabled]="!hospitalForm.valid || !UserForm.valid">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>
        </div>
    </div>
</mat-dialog-actions>
